import React, { useContext, useMemo } from 'react';

import { MobileContext } from 'context';
import { useNewestRoundID } from 'utils/Hooks';
import Section from './section';
import './styles.scss';

function StoplightCard(props) {
  const length = 9;
  const isMobile = useContext(MobileContext);

  const newestRoundID = useNewestRoundID();


  function NumberOfRoundsToDraw() {
    const lastEndedRoundID = newestRoundID - 2;
    const firstEndedRoundID = lastEndedRoundID - length;
    if (firstEndedRoundID < 1)
      return lastEndedRoundID;
    else
      return length;
  }

  const sectionsM = useMemo(Sections, [newestRoundID])
  function Sections() {
    const lastEndedRoundID = newestRoundID - 2;
    let allSections = [];
    for (let i = NumberOfRoundsToDraw(); i > 0; i--) {
      const wantedRoundID = lastEndedRoundID - NumberOfRoundsToDraw() + i;
      const newSection = (
        <Section key={wantedRoundID} roundID={wantedRoundID} />
      );
      allSections.push(newSection);
    }
    //allSections.push(<Section key={30} roundID={30} contract={contract} />); // debug
    return <div className="h-full">{allSections}</div>;
  }

  return (
    <div className={'ThemeCardBase Card Stoplight' + (isMobile ? ' Mobile' : ' Desktop')}>
      {sectionsM}
    </div>
  );
}

export default StoplightCard;
